import React from "react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import IndustriesSection from "@/components/sections/IndustriesSection";
import FinalCTA from "@/components/sections/FinalCTA";

export default function IndustriesPage() {
  return (
    <>
      <SEO
        title="Industries We Support | Premier Global Sourcing"
        description="Sourcing support for retail, e-commerce, industrial supplies, machinery, construction materials, hospitality and consumer products."
        path="/industries"
      />
      <PageHero
        eyebrow="Industries"
        title="Sourcing support for diverse business requirements"
        intro="Whatever your sector, we tailor the requirement review to your products and buying needs."
        breadcrumbs={[{ label: "Industries" }]}
      />
      <IndustriesSection chapter="" />
      <FinalCTA />
    </>
  );
}
